module.exports = __webpack_public_path__ + "img/delivery-glovo.00adf5b3.svg";